import React from 'react';
import { PropTypes } from 'prop-types';
import { CardDetail, CardSubHeader } from 'common/Card';
import { get } from 'lodash';
import { epochToDate } from 'common/utils/utils';
import useClientNameRenderer from 'src/common/hooks/useClientNameRenderer';

const ClientDetailsSection = ({
  enrollmentRequest,
  primaryInsurance,
  showClientFacesheetLink,
  onClientNameClick,
}) => {
  const externalMemberID = primaryInsurance?.external_member_id;

  const handleClientNameClick = () => {
    if (onClientNameClick) {
      onClientNameClick(enrollmentRequest.person);
    }
  };

  const { renderClientName } = useClientNameRenderer({
    clientData: enrollmentRequest.person,
    hasAccess: showClientFacesheetLink,
    onDrawerOpen: handleClientNameClick,
    additionalProps: {
      nameFormat: 'lastFirst',
      textSize: 'text-sm',
    },
  });

  return (
    <>
      <CardSubHeader>Client Details</CardSubHeader>
      <CardDetail label="Client Name">
        {renderClientName()}
      </CardDetail>
      {externalMemberID && (
        <CardDetail label="Insurance Member ID">
          {externalMemberID}
        </CardDetail>
      )}
      {primaryInsurance && (
        <CardDetail label="Insurance Plan">
          {primaryInsurance.plan?.name}
        </CardDetail>
      )}
      <CardDetail label="Date of Birth">{epochToDate(get(enrollmentRequest, 'person.date_of_birth'))}</CardDetail>
    </>
  );
};

ClientDetailsSection.propTypes = {
  enrollmentRequest: PropTypes.object.isRequired,
  primaryInsurance: PropTypes.object.isRequired,
  showClientFacesheetLink: PropTypes.bool.isRequired,
  onClientNameClick: PropTypes.func,
};

ClientDetailsSection.defaultProps = {
  onClientNameClick: null,
};

export default ClientDetailsSection;
